let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iMnjN")).then(() => parcelRequire('jqyo2'));